import type { UserIP } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import { X } from "lucide-react";

interface UserIpFilterProps {
  value: UserIP;
  onChange: (value: UserIP) => void;
}

export function UserIpFilter({ value, onChange }: UserIpFilterProps) {
  const addBlock = () => onChange({ ...value, blocks: [...value.blocks, ""] });
  const updateBlock = (i: number, v: string) => {
    const next = [...value.blocks];
    next[i] = v;
    onChange({ ...value, blocks: next });
  };
  const removeBlock = (i: number) =>
    onChange({ ...value, blocks: value.blocks.filter((_, j) => j !== i) });

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Switch
          checked={value.prefer_client_ip}
          onCheckedChange={(v) => onChange({ ...value, prefer_client_ip: v })}
        />
        <Label className="text-xs">Prefer Client IP</Label>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label className="text-xs">IP Blocks</Label>
          <Button type="button" variant="outline" size="sm" onClick={addBlock}>
            Add Block
          </Button>
        </div>
        {value.blocks.map((block, i) => (
          <div key={i} className="flex items-center gap-2">
            <Input
              value={block}
              onChange={(e) => updateBlock(i, e.target.value)}
              placeholder="cidr block"
              className="flex-1"
            />
            <Button type="button" variant="ghost" size="icon" onClick={() => removeBlock(i)}>
              <X className="h-4 w-4 text-red" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
